import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  text: 'Llegué al Día 1 sin esperanza. En el Día 12 volví a sentir que Dios me sostenía. No cambió nada afuera. Cambié yo por dentro.',
  author: 'María T.',
  role: 'México',
  date: 'Feb 14, 2026',
  avatar: 'MT',
  rating: 5,
  verified: true,
  highlight: 'Día 12 — volví a sentir que Dios me sostenía'
}, {
  text: 'No soy de leer. Pero estos 5 minutos cada mañana se convirtieron en lo único que me mantuvo en pie durante los peores meses de mi vida.',
  author: 'Roberto G.',
  role: 'Colombia',
  date: 'Ene 28, 2026',
  avatar: 'RG',
  rating: 5,
  verified: true,
  highlight: '5 minutos que me mantuvieron en pie'
}, {
  text: 'Pensé que era otro libro de autoayuda con versículos. Me equivoqué completamente. Es como una conversación honesta con alguien que entendió exactamente lo que estaba viviendo.',
  author: 'Carmen L.',
  role: 'España',
  date: 'Feb 3, 2026',
  avatar: 'CL',
  rating: 5,
  verified: true,
  highlight: 'No es autoayuda — es honestidad real'
}, {
  text: 'Llevaba meses sintiéndome lejos de Dios. Este libro me dio permiso para estar triste y aun así buscarlo. Fue como un abrazo en la oscuridad.',
  author: 'Ana María G.',
  role: 'Argentina',
  date: 'Ene 15, 2026',
  avatar: 'AG',
  rating: 5,
  verified: true,
  highlight: 'Permiso para estar triste y aun así buscar a Dios'
}, {
  text: 'No es un libro para leer rápido. Es para leer un poquito y dejar que te sane. Me enseñó que mi dolor no espanta a Dios.',
  author: 'Carlos R.',
  role: 'Chile',
  date: 'Feb 8, 2026',
  avatar: 'CR',
  rating: 5,
  verified: true,
  highlight: 'Mi dolor no espanta a Dios'
}, {
  text: 'Justo lo que necesitaba en mi momento más difícil. Sentí que alguien por fin entendía que no podía estar bien todo el tiempo.',
  author: 'Lucía M.',
  role: 'Perú',
  date: 'Feb 19, 2026',
  avatar: 'LM',
  rating: 5,
  verified: true,
  highlight: 'Alguien que por fin entendió'
}];
function StarRating({
  count = 5
}: {
  count?: number;
}) {
  return <div className="flex items-center gap-0.5" data-id="element-303">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-3.5 h-3.5 ${i < count ? 'fill-[#00b67a] text-[#00b67a]' : 'text-gray-300'}`} data-id="element-304" />)}
    </div>;
}
function AvatarCircle({
  initials
}: {
  initials: string;
}) {
  const colors: Record<string, string> = {
    MT: '#7c6b3a',
    RG: '#5a7c6b',
    CL: '#6b5a7c',
    AG: '#7c5a5a',
    CR: '#5a6b7c',
    LM: '#7c7a5a'
  };
  const bg = colors[initials] || '#7c6b3a';
  return <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{
    backgroundColor: bg
  }} data-id="element-305">
      {initials}
    </div>;
}
export function TestimonialsSection() {
  const avgRating = 4.9;
  const totalReviews = 847;
  return <section className="py-14 px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-306">
      <div className="max-w-[860px] mx-auto" data-id="element-307">
        {/* Header — Trustpilot style */}
        <div className="text-center mb-10" data-id="element-308">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-3" data-id="element-309">
            Reseñas Verificadas
          </p>
          <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] mb-6" data-id="element-310">
            Lo que dicen quienes ya cruzaron el desierto
          </h2>

          {/* Aggregate score */}
          <div className="inline-flex items-center gap-6 bg-[var(--bg-card)] border border-[var(--border-subtle)] rounded-xl px-6 py-4 shadow-sm" data-id="element-311">
            <div className="text-center" data-id="element-312">
              <div className="text-4xl font-bold text-[var(--text-heading)] font-serif leading-none mb-1" data-id="element-313">
                {avgRating}
              </div>
              <StarRating count={5} data-id="element-314" />
              <p className="text-[10px] text-[var(--text-muted)] mt-1 uppercase tracking-wide" data-id="element-315">
                Excelente
              </p>
            </div>
            <div className="w-px h-12 bg-[var(--border-subtle)]" data-id="element-316" />
            <div className="text-left" data-id="element-317">
              {[5, 4, 3, 2, 1].map(star => <div key={star} className="flex items-center gap-2 mb-1" data-id="element-318">
                  <span className="text-[10px] text-[var(--text-muted)] w-2" data-id="element-319">
                    {star}
                  </span>
                  <div className="w-20 h-1.5 bg-[var(--bg-elevated)] rounded-full overflow-hidden" data-id="element-320">
                    <div className="h-full rounded-full" style={{
                  backgroundColor: '#00b67a',
                  width: star === 5 ? '92%' : star === 4 ? '6%' : '1%'
                }} data-id="element-321" />
                  </div>
                </div>)}
            </div>
            <div className="w-px h-12 bg-[var(--border-subtle)]" data-id="element-322" />
            <div className="text-center" data-id="element-323">
              <div className="text-xl font-bold text-[var(--text-heading)]" data-id="element-324">
                {totalReviews.toLocaleString()}+
              </div>
              <p className="text-[10px] text-[var(--text-muted)] uppercase tracking-wide" data-id="element-325">
                Lectores
              </p>
            </div>
          </div>
        </div>

        {/* Review cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-326">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07
        }} className="bg-[var(--bg-card)] rounded-xl border border-[var(--border-subtle)] p-5 flex flex-col gap-3 shadow-sm" data-id="element-327">
              {/* Top row */}
              <div className="flex items-start justify-between gap-2" data-id="element-328">
                <div className="flex items-center gap-3" data-id="element-329">
                  <AvatarCircle initials={t.avatar} data-id="element-330" />
                  <div data-id="element-331">
                    <p className="text-[var(--text-heading)] text-sm font-bold leading-tight" data-id="element-332">
                      {t.author}
                    </p>
                    <p className="text-[var(--text-muted)] text-[11px]" data-id="element-333">
                      {t.role}
                    </p>
                  </div>
                </div>
                {t.verified && <div className="flex items-center gap-1 text-[10px] text-[#00b67a] flex-shrink-0" data-id="element-334">
                    <CheckCircle className="w-3 h-3" data-id="element-335" />
                    <span data-id="element-336">Verificado</span>
                  </div>}
              </div>

              {/* Stars + date */}
              <div className="flex items-center justify-between" data-id="element-337">
                <StarRating count={t.rating} data-id="element-338" />
                <span className="text-[10px] text-[var(--text-muted)]" data-id="element-339">
                  {t.date}
                </span>
              </div>

              {/* Highlight badge */}
              <div className="bg-[var(--accent-soft)] border border-[var(--accent)]/20 rounded px-2.5 py-1.5" data-id="element-340">
                <p className="text-[var(--accent)] text-[11px] font-semibold leading-snug" data-id="element-341">
                  "{t.highlight}"
                </p>
              </div>

              {/* Full review */}
              <p className="text-[var(--text-muted)] text-sm leading-relaxed flex-1 italic" data-id="element-342">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>

        {/* Footer trust line */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 text-xs text-[var(--text-muted)]" data-id="element-343">
          <div className="flex items-center gap-1.5" data-id="element-344">
            <CheckCircle className="w-3.5 h-3.5 text-[#00b67a]" data-id="element-345" />
            <span data-id="element-346">Reseñas de compradores verificados</span>
          </div>
          <span className="hidden sm:inline opacity-30" data-id="element-347">·</span>
          <div className="flex items-center gap-1" data-id="element-348">
            <StarRating count={5} data-id="element-349" />
            <span className="ml-1" data-id="element-350">4.9/5 promedio</span>
          </div>
          <span className="hidden sm:inline opacity-30" data-id="element-351">·</span>
          <span data-id="element-352">+847 personas ya comenzaron su Día 1</span>
        </div>
      </div>
    </section>;
}